import React, { useEffect, useState } from "react";
import useLogout from "../../hooks/useLogout";
import { toast } from "react-toastify";
import { getAppointmentListAPI } from "../../api/master/indes";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, Button, Icon, TooltipComponent } from "../../components/Component";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { Badge } from "reactstrap";
import { approvePartnerUserApplicationAPI, listPartnerUserApplicationAPI } from "../../api/user";
import { UserAvatarCell } from "../../MyComp/ImagePre/UserAvatarCell";
import { useForm } from "react-hook-form";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import PartnerApprovalModal from "../../MyComp/UI/modals/PartnerApprovalModal";

const UserBecomePartnerApplications = () => {
      const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        setError,
        clearErrors,
        reset,
        formState: { errors },
      } = useForm({
        defaultValues: {
          isLoading: false,
          loading: false,
          data: [],
        },
      });
        
      const isLoading = watch("isLoading"); 
      const [imageOpen, setImageOpen] = useState(false);
      const [appModal, setAppModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([
    {
         name: "User",
         selector: (row) => row?.name,
         cell: (row) => (
           <div
             style={{
               display: "flex",
               alignItems: "center",
               gap: "12px",
               padding: "6px 0",
             }}
           >
             
             <UserAvatarCell row={row} image={`${BASE_URL_IMG}` + row?.profileImage} name={row?.name} handleImageOpenPreview={handleImageOpenPreview} />
   
   
             <div style={{ display: "flex", flexDirection: "column" }}>
               <span
                 style={{
                   fontWeight: 600,
                   fontSize: "15px",
                   color: "#111827",
                   lineHeight: "1.2",
                 }}
                 className="text-capitalize"
               >
                  
                 {row?.name || "N/A"}
               </span>
               <span
                 style={{
                   fontSize: "13px",
                   color: "#6b7280",
                 }}
               >
                 {row?.mobile || "No mobile"}
               </span>
             </div>
           </div>
         ),
         sortable: true,
         width: "300px",
       },
   
    {
      name: "PAN",
      selector: (row) => <>
      
       <img
            src={row?.pan_image ? `${BASE_URL_IMG}${row.pan_image}` : "/default-avatar.png"}
            alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.pan_image)}
          /> </>,
      sortable: true,
    },
    {
      name: "Aadhaar",
      selector: (row) => <>
       <img
            src={row?.aadhar_front_image ? `${BASE_URL_IMG}${row.aadhar_front_image}` : "/default-avatar.png"}
            alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.aadhar_front_image)}
          /> 
       <img
            src={row?.aadhar_back_image ? `${BASE_URL_IMG}${row.aadhar_back_image}` : "/default-avatar.png"}
            alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.aadhar_back_image)}
          /> 
      </>,
      sortable: true,
    },
    
    {
      name: "Bank",
      selector: (row) => <>
       <img
            src={row?.passbook_image ? `${BASE_URL_IMG}${row.passbook_image}` : "/default-avatar.png"}
            alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.passbook_image)}
          /> 
      </>,
      sortable: true,
    },
    
    
    
    {
      name: "Status",
      selector: (row) => (
        <>
          <Badge
            className="text-capitalize"
            color={`${
              row?.is_verified 
                ? "outline-primary"
                : "outline-warning"
               
            }`}
          >
            {row?.is_verified?"Approved":"Pending"}
          </Badge>
        </>
      ),
      sortable: true,
    },
    {
        name:"Action",
        selector:(row)=>(
                          <div className="d-flex flex-column m-1 justify-content-center align-items-center h-100">
                {/* <Button
                  outline
                  style={{ width: "50px" }}
                  color={`warning`}
                  size={`xs`}
                  id={`profile-${row?.id}`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  onClick={() => viewDoctorProfile(row)}
                >
                  {" "}
                  <Icon name="eye" />
                </Button>
                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`profile-${row?.id}`}
                  text="View Application Detail"
                /> */}
               {row?.is_verified?null: <Button
                  outline
                  style={{ width: "50px" }}
                  color={`success`}
                  size={`xs`}
                  id={`app-${row?.id}`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  onClick={() => approveApplication(row)}
                >
                  {" "}
                  <Icon name="check" />
                </Button>}
                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`app-${row?.id}`}
                  text="Approve Application"
                /> 
                 </div>
        )
    }
    
  ]);
   const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
    const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const logout = useLogout();
  useEffect(() => {
    getPartnerApplicationList();
  }, []);
  const getPartnerApplicationList = () => {
    listPartnerUserApplicationAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const approveApplication=(row)=>{
    setValue("isApp", true);
    setValue("selectedRow",row)
    setAppModal(true)
  }
  const toggleApp =()=>{
    setAppModal(false)
  }
  const onConfirm = (data)=>{
    const formData = new FormData()
  
    const updatedPub = watch("selectedRow").is_verified === true ? false : true;
    if (watch("isApp")) {
      formData.append("is_verified", updatedPub);
    }
    formData.append("id", watch("selectedRow")?.id);
    formData.append("user_id", watch("selectedRow")?.user_id);


    const body ={
        is_verified:  updatedPub,
        id:watch("selectedRow")?.id,
        user_id:watch("selectedRow")?.user_id
    }
    setValue("isLoading", true);
    approvePartnerUserApplicationAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getPartnerApplicationList();
          setAppModal(false);
          setValue("isLoading", false);
          setAppModal(false);
          reset();
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title="Partner User List" />
      <Content>
        <Block>
          <MyDataTable title="Partner User List" isLoading={loading} data={data} columns={columns} />
        </Block>
      </Content>
 <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />


<PartnerApprovalModal isOpen={appModal} toggle={toggleApp} status={watch("selectedRow")?.is_verified}  onConfirm={onConfirm}/>



    </>
  );
};

export default UserBecomePartnerApplications;
